import styled from '@emotion/styled';

export const ColumnFlexBox = styled.div<{ gap?: string }>`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  gap: ${(props) => props.gap ?? '0'};
`;
